export const DataGridColumnType = {
  Text: 0,
  Number: 1,
  Date: 2,
  Time: 3,
  Select: 4,
  Boolean: 5,
  Custom: 6,
  MultiSelect: 7,
  DateTime: 8,
} as const;
export type DataGridColumnType = (typeof DataGridColumnType)[keyof typeof DataGridColumnType];
